module.exports = __webpack_public_path__ + "img/singapore_expo_logo.e042843f.png";